<template>
    <modal :title="$t('OrderPending.pickupDeliveryTab.define_zone')" @close-request="$emit('closeModal', billingType)" closable>
        <div class="mx-3">
            <div class="zones-containor">
                <div class="map-div">
                    <gmap-map id="zone-map" :zoom="8" :center="center" ref="mapRef"></gmap-map>
                </div>
                <div class="mobile-toggle" v-if="isMobile">
                  <button
                    class="btn-toggle"
                    @click="toggleMap()"
                  >
                    {{ showZoneList ? 'Hide Zone List' : 'Show Zone List' }}
                  </button>
                </div>
                <div class="zones-list-div" v-show="!isMobile || showZoneList">
                    <zone-pricing-modal v-if="showModal" :zone="zone" :allowActions="true"
                        @closeModal="closeModal"></zone-pricing-modal>
                    <button v-if="!showAdd && !showEdit" class="btn btn-kne-orange w-100"
                        @click="addPolygon">{{ $t('Zones.add_new_zone') }}</button>
                    <div v-if="!showAll && zones.length">
                        <button v-on:click="showAll = !showAll"
                            class="btn btn-kne-orange w-100 shw-btn m-b-8">{{ $t('Zones.show_all_zones') }}</button>
                    </div>
                    <div v-if="showAll && zones.length">
                        <button v-on:click="showAll = !showAll"
                            class="btn w-100 btn-blk shw-btn m-b-8">{{ $t('Zones.hide') }}</button>
                    </div>
                    <regular-input v-if="showAdd" min="0" :value="areaName" @input="areaName = $event" type="text"
                        :placeholder="$t('Zones.zone_name')" />
                    <div class="btns-cont">
                        <button v-if="showAdd" class="btn btn-kne-orange"
                            @click="addZone()">{{ $t('Zones.save_and_close') }}</button>
                        <button v-if="showAdd" class="btn  btn-blk btn-cnl"
                            @click="cancelAdd()">{{ $t('Zones.cancel') }}</button>
                    </div>

                    <regular-input v-if="showEdit" min="0" :value="zoneName" @input="zoneName = $event" type="text" />
                    <div class="btns-cont">
                        <button v-if="showEdit" class="btn btn-kne-orange"
                            @click="updateZone()">{{ $t('Zones.save_and_close') }}</button>
                        <button v-if="showEdit" class="btn btn-blk btn-cnl"
                            @click="cancelEdit()">{{ $t('Zones.cancel') }}</button>
                    </div>

                    <div style="display: flex;" class="m-b-8 pr-ctr" v-if="!showAdd && !showEdit && zones.length">
                        <button class="w-btn n-b-r" :class="{ 'active': operation === '+' }"
                            @click="operation = '+'">+</button>
                        <button class="w-btn" :class="{ 'active': operation === '-' }" @click="operation = '-'">-</button>
                        <regular-input style="flex: 2;" min="0" :value="price" @input="price = $event" type="number"
                            :placeholder="$t('Zones.price')" />
                        <button class="w-btn n-b-r" @click="updateAllZonesPrice(operation, '$')">$</button>
                        <button class="w-btn" @click="updateAllZonesPrice(operation, '%')">%</button>
                    </div>

                    <div style="display: flex;" class="m-b-8 pr-ctr" v-if="!showAdd && !showEdit && zones.length">
                        <input style="flex: 2" class="search-inp form-control" type="text"
                            @input="onSearchInput($event)" @keyup.enter="filterZones()"
                            :placeholder="$t('Zones.search')" />
                        <button class="w-btn" @click="filterZones()" id="search-btn">
                            <i class="fa fa-search" />
                        </button>
                    </div>

                    <div class="selectall-ctr" v-if="!showAdd && !showEdit && zones.length">
                        <input type="checkbox" id="selectAll" @change="selectAllZones($event.target.checked)">
                        <h1>{{ $t('Zones.select_all') }}</h1>
                    </div>

                    <div class="zones-div">
                        <div v-if="!showAdd && !showEdit" v-for="(zone, index) in filteredZones" :key="zone.id">
                            <div class="zone-div">
                                <input type="checkbox" :key="zone.id" name="options" :id="zone.id"
                                    v-model="selectedZones[zone.id]" :checked="selectedZones[zone.id]">
                                <h1 class="zone-name" @click="openModal(zone)">{{ zone.zoneName }}</h1>
                                <hover-tool-tip :text="zone.zoneName" :clickable="true" />
                                <div class="zone-btns-cont">
                                    <button class="btn-view" @click="showPolygon(zone)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="svg-icn">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                        </svg>
                                    </button>
                                    <button class="btn-edit" @click="editPolygon(zone)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="svg-icn">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                        </svg>
                                    </button>
                                    <button class="btn-del" @click="deleteZone(zone.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            class="svg-icn">
                                            <path fill-rule="evenodd"
                                                d="M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div> 
    </modal>
</template>

<script>
import { db } from '../../../../firebase'
import { gmapApi } from 'vue2-google-maps'
import * as turf from '@turf/turf'
import RegularInput from '../../../module/basic-components/regularInput'
import * as firebaseUtil from '../../../../firebase.js'
import ZonePricingModal from '../../../module/special-components/Modal-templates/ZonePricing-modal.vue'
import HoverToolTip from '../../../module/basic-components/hoverToolTip.vue'
import Modal from '../../interface-components/Modal.vue'

export default {
  name: 'NewZoneModal',
  components: {
    RegularInput,
    ZonePricingModal,
    HoverToolTip,
    Modal
  },

  props: {
        isNewZoneModal: Boolean,
        billingLatLong: Object,
        transmitterLatLong: Object,
        receiverLatLong: Object,
        billingType: String
    },

  data () {
    return {
      areaName: '',
      zones: [],
      map: null,
      showZoneList: true,
      isMobile: false,
      drawingManager: null,
      newZoneCoordinates: [],
      center: {lat: 45.5374842, lng: -73.6034393},
      zone: null,
      zoneName: '',
      showAll: true,
      showAdd: false,
      showEdit: false,
      showModal: false,
      filteredZones: [],
      search: '',
      zoneNames: [],
      zoneIdToNameMap: {},
      selectedZones: {},
      price: '',
      operation: '+',
      activeUsers: {},
      joinedAt: new Date(),
      allowActions: false,
      activeUsersListener: null,
      activeUsersInterval: null,
      firebaseUtil,
      usStatesData: [],
      canadaProvincesData: []
    }
  },

  mounted () {
    this.initializeMap()
    this.isMobile = window.innerWidth < 700
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    async initializeMap () {
      await this.fetchGeoJsonData()
      await this.getZones()
      const polygonCenter = this.polygonCenter
      function getRandomColor () {
        let letters = '0123456789ABCDEF'
        let color = '#'
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      }
      if (!this.google) {
        console.error('Google object is not defined yet.', this.google)
        setTimeout(this.initializeMap, 100)
        return
      }
      // Used for centering the map on the address for which zone is to be created
      let centerLatLog = {
        lat: null,
        long: null
      }
      if (this.billingType === 'BILLING') {
        centerLatLog.lat = this.billingLatLong.lat
        centerLatLog.long = this.billingLatLong.long
      } else if ((this.billingType === 'PICKUP')) {
        centerLatLog.lat = this.transmitterLatLong.lat
        centerLatLog.long = this.transmitterLatLong.long
      } else {
        centerLatLog.lat = this.receiverLatLong.lat
        centerLatLog.long = this.receiverLatLong.long
      }
      let mapOptions = {
        zoom: 10,
        mapTypeControl: false,
        streetViewControl: false,
        scaleControl: false,
        fullscreenControl: false,
        center: new this.google.maps.LatLng(centerLatLog.lat || 45.5374842, centerLatLog.long || -73.6034393)
      }
      let map = new this.google.maps.Map(document.getElementById('zone-map'), mapOptions)
      this.map = map
      const trafficLayer = new this.google.maps.TrafficLayer()
      trafficLayer.setMap(map)
      this.drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [this.google.maps.drawing.OverlayType.POLYGON]
        },
        polygonOptions: {
          fillColor: '#BCDCF9',
          fillOpacity: 0.35,
          strokeWeight: 3,
          strokeColor: '#57ACF9',
          clickable: false,
          editable: true,
          zIndex: 1
        }
      })
      let google = this.google
      let zoneIdToNameMap = {}
      let zoneNames = []
      // Add a marker on this coordinate
      const svgMarker = {
        path: 'M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z',
        fillColor: '#f7941e',
        fillOpacity: 0.8,
        strokeWeight: 0,
        rotation: 0,
        scale: 2
      }
      const markerLat = centerLatLog.lat || 45.5374842
      const markerLng = centerLatLog.long || -73.6034393
      let markerObj = new google.maps.Marker({
        position: { lat: markerLat, lng: markerLng },
        icon: svgMarker
      })
        markerObj.setMap(map)
      this.zones.forEach(function (element, index) {
        try {
          zoneNames.push(element.zoneName)
          zoneIdToNameMap[element.id] = element.zoneName
          element.coords = element.coordinates
        } catch (e) {
          return
        }
        let arry = []
        if (!Array.isArray(element.coordinates)) {
          return
        }
        element.coordinates.forEach(function (elem, idx) {
          if (elem[0] != null && elem[1] != null) {
            arry.push(new google.maps.LatLng(elem[1], elem[0]))
          }
        })
        if (arry != null) {
          element.coordinates = arry
        }
        const color = element.color ? element.color : getRandomColor()
        element.color = color
        let polygonObj = new google.maps.Polygon({
          paths: element.coordinates,
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: color,
          fillOpacity: 0.60
        })
        element.polygon = polygonObj
        polygonObj.setMap(map)
        const polyCenter = polygonCenter(element.coords)
        let markerObj = new google.maps.Marker({
          position: polyCenter,
          label: { text: element.zoneName, color: 'black', fontSize: '18px', fontWeight: '400' },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
          }
        })
        markerObj.setMap(map)
        element.marker = markerObj
      })
      this.zoneNames = zoneNames
      this.zoneIdToNameMap = zoneIdToNameMap
      this.google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
        this.drawingManager.setDrawingMode(null)
        this.handlePolygonChange(polygon)
        this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
          this.handlePolygonChange(polygon)
        })
        this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
          this.handlePolygonChange(polygon)
        })
        this.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
          this.handlePolygonChange(polygon)
        })
      })
      this.filterZones()
    },
    handleResize () {
      this.isMobile = window.innerWidth < 700
      if (!this.isMobile) this.showZoneList = true // always show both on desktop
    },
    toggleMap () {
      this.showZoneList = !this.showZoneList
    },
    handlePolygonChange (polygon) {
        let polygonArr = []
        for (let i = 0; i < polygon.getPath().getLength(); i++) {
          let point = [
            polygon.getPath().getAt(i).lng(),
            polygon.getPath().getAt(i).lat()
          ]
          polygonArr.push(point)
        }
        this.newZoneCoordinates = polygonArr
    },
    polygonCenter (poly) {
      let lats = poly.map((point) => point[1])
      let lngs = poly.map((point) => point[0])

      let lowx = Math.min(...lats)
      let highx = Math.max(...lats)
      let lowy = Math.min(...lngs)
      let highy = Math.max(...lngs)

      let centerX = lowx + (highx - lowx) / 2
      let centerY = lowy + (highy - lowy) / 2

      return { lat: centerX, lng: centerY }
    },
    polygonProvince (center) {
      const point = turf.point([center.lng, center.lat])
      for (const feature of this.canadaProvincesData.features) {
        if (turf.booleanPointInPolygon(point, feature)) {
          return feature.properties.name
        }
      }
      for (const feature of this.usStatesData.features) {
        if (turf.booleanPointInPolygon(point, feature)) {
          return feature.properties.name
        }
      }
      return null
    },
    checkPolygonIntersection (polygon1, polygon2) {
      const feature1 = turf.polygon(polygon1, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const feature2 = turf.polygon(polygon2, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const intersects = turf.booleanIntersects(feature1, feature2)
      return intersects
    },
    mapPolygons (polygon) {
      let arr = [[...polygon]]
      arr[0].push(arr[0][0])
      return arr
    },
    isZoneIntersecting (newZoneCoordinates, zones) {
      let intersecting = false
      zones.forEach((zone) => {
        if (this.zone && this.zone.id === zone.id) {
          return
        }
        if (this.checkPolygonIntersection(this.mapPolygons(newZoneCoordinates), this.mapPolygons(zone.coords))) {
          intersecting = true
          return
        }
      })
      return intersecting
    },
    addZone () {
      if (!this.areaName) {
        confirm('Please enter zone name before saving')
        return
      }
      if (this.zoneNames.includes(this.areaName)) {
        confirm('Zone name is already present. Please enter a different name.')
        return
      }
      if (!this.newZoneCoordinates || this.newZoneCoordinates.length === 0) {
        confirm('Please draw the polygon on map before saving')
        return
      }
      if (this.newZoneCoordinates.length < 3) {
        confirm('Please draw a proper polygon before saving')
        return
      }
      if (this.isZoneIntersecting(this.newZoneCoordinates, this.zones)) {
          alert('Zone intersecting with another')
          return
      }
      const center = this.polygonCenter(this.newZoneCoordinates)
      const point = [center.lat, center.lng]
      const province = this.polygonProvince(center)
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').push().set(
        {
          zoneName: this.areaName,
          coordinates: this.newZoneCoordinates,
          center: point,
          province
        }
      ).then(() => {
        console.log('Zone added')
        this.areaName = ''
        this.search = ''
        this.newZoneCoordinates = []
        this.showAdd = false
        this.$emit('closeModal', this.billingType)
      }).catch(function (error) {
        console.error(error)
      })
    },
    updateZone () {
      if (!this.zoneName) {
        confirm('Please enter zone name before saving')
        return
      }
      if (this.zone.zoneName !== this.zoneName && this.zoneNames.includes(this.zoneName)) {
        confirm('Zone name is already present. Please enter a different name.')
        return
      }
      if (this.isZoneIntersecting(this.newZoneCoordinates, this.zones)) {
          alert('Zone intersecting with another')
          return
      }
      const center = this.polygonCenter(this.newZoneCoordinates)
      const point = [center.lat, center.lng]
      const province = this.polygonProvince(center)
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').child(this.zone.id).update(
        {
          zoneName: this.zoneName,
          coordinates: this.newZoneCoordinates,
          center: point,
          province
        }
      ).then(() => {
        console.log('Zone updated')
        this.showEdit = false
        this.newZoneCoordinates = []
        this.zone = {}
        this.search = ''
        this.$emit('closeModal', this.billingType)
      }).catch(function (error) {
        console.error(error)
      })
    },
    async getZones () {
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      this.zones = this.$store.state.zones.map(zone => ({ ...zone }))
      return Promise.resolve()
    },
    showPolygon (zone) {
      zone.polygon.setMap(this.map)
      zone.marker.setMap(this.map)
      this.map.setCenter(this.polygonCenter(zone.coords))
      this.map.setZoom(10)
    },
    addPolygon () {
      this.showAdd = !this.showAdd
      this.drawingManager.setMap(this.map)
      console.log(1)
    },
    cancelAdd () {
      this.showAdd = false
      this.areaName = ''
      this.search = ''
      this.newZoneCoordinates = []
      this.selectAllZones(false)
      this.selectedZones = {}
      this.drawingManager.setMap(null)
      this.initializeMap()
    },
    editPolygon (zone) {
      this.showAdd = false
      this.showEdit = true
      this.zone = zone
      this.zoneName = zone.zoneName
      this.newZoneCoordinates = zone.coords
      zone.polygon.setEditable(true)
      zone.polygon.setDraggable(true)
      zone.polygon.setMap(this.map)
      this.map.setCenter(this.polygonCenter(zone.coords))
      this.map.setZoom(10)
      this.google.maps.event.addListener(zone.polygon.getPath(), 'set_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
      this.google.maps.event.addListener(zone.polygon.getPath(), 'insert_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
      this.google.maps.event.addListener(zone.polygon.getPath(), 'remove_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
    },
    cancelEdit () {
      this.newZoneCoordinates = []
      this.zoneName = ''
      this.search = ''
      this.showEdit = false
      this.selectAllZones(false)
      this.selectedZones = {}
      this.initializeMap()
    },
    deleteZone (zone) {
      if (!confirm('Please confirm to delete zone')) {
        return
      }
      db.ref(`database/zones/transporter/${this.companyUID}/zone/${zone}`).remove()
          .then(() => {
            console.log('Zone deleted')
            this.initializeMap()
          })
          .catch(error => {
            console.error('Error deleting zone from Firebase:', error)
          })
    },
    openModal (zone) {
      this.zone = zone
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.initializeMap()
    },
    updateAllZonesPrice (operation, unit) {
      if (!operation) {
        confirm('Please select operation')
        return
      }
      if (!unit) {
        confirm('Please select unit')
        return
      }
      if (!this.price) {
        confirm('Please enter price')
        return
      }
      let selectedZoneNames = []
      Object.entries(this.selectedZones).forEach(entry => {
        if (entry[1]) {
          selectedZoneNames.push(this.zoneIdToNameMap[entry[0]])
        }
      })
      if (selectedZoneNames.length === 0) {
        confirm('Please select zones')
        return
      }
      if (!confirm(`Please confirm to update price for zones - ${selectedZoneNames.join(', ')}`)) {
        return
      }
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').once('value', (snapshot) => {
        let zoneNode = snapshot.val()
        Object.entries(zoneNode).forEach(key => {
          if (!this.selectedZones[key[0]]) {
            return
          }
          if (Object.entries(key[1]).length > 2) {
            Object.keys(key[1]).forEach(zoneInfo => {
              if (zoneInfo !== 'zoneName' && zoneInfo !== 'coordinates') {
                let existingPrice = key[1][zoneInfo].price
                if (existingPrice) {
                  let currentPrice = null
                  if (operation === '+') {
                    if (unit === '$') {
                      currentPrice = Number(existingPrice) + Number(this.price)
                    } else { // percentage
                      let num = Number(existingPrice) * Number(this.price) / 100
                      currentPrice = Number(existingPrice) + num
                    }
                  } else {
                    if (unit === '$') {
                      currentPrice = Number(existingPrice) - Number(this.price)
                    } else { // percentage
                      let num = Number(existingPrice) * Number(this.price) / 100
                      currentPrice = Number(existingPrice) - num
                    }
                  }
                  // update price in node
                  zoneNode[key[0]][zoneInfo]['price'] = currentPrice
                }
              }
            })
          }
        })
        // update in firebase db here
        db.ref('database/zones/transporter').child(this.companyUID).child('zone').update(
          zoneNode
        ).then(() => {
          document.getElementById('selectAll').checked = false
          this.selectAllZones(false)
          this.selectedZones = {}
          this.price = ''
          this.operation = '+'
          console.log('Zone pricing updated')
          this.initializeMap()
        }).catch(function (error) {
          console.error(error)
        })
      })
    },
    onSearchInput (event) {
      this.search = event.target.value
      if (this.search === '') {
        this.filterZones()
      }
    },
    filterZones () {
      if (!this.search) {
        this.filteredZones = this.zones
      }
      this.filteredZones = this.zones.filter(zone => zone.zoneName.toLowerCase().includes(this.search.toLowerCase()))
    },
    selectAllZones (checked) {
      const checkboxes = document.querySelectorAll('input[name="options"]')
      checkboxes.forEach(checkbox => {
        checkbox.checked = checked
        this.selectedZones[checkbox.id] = checked
      })
    },
    isPastDate (dateString) {
      const inputDate = new Date(dateString)
      const currentDate = new Date()
      if (isNaN(inputDate.getTime())) {
        return false
      }
      const timeDifference = currentDate.getTime() - inputDate.getTime()
      return timeDifference >= 7000
    },
    async fetchGeoJsonData () {
      try {
        const usResponse = await fetch('https://raw.githubusercontent.com/PublicaMundi/MappingAPI/master/data/geojson/us-states.json')
        this.usStatesData = await usResponse.json()
        const canadaResponse = await fetch('https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/canada.geojson')
        await canadaResponse.json().then((data) => {
          this.canadaProvincesData = data
        })
      } catch (error) {
        this.errorMessage = error.message
      }
    }
  },
  watch: {
    showAll (value) {
      if (value) {
        this.zones.forEach(zone => {
          zone.polygon.setMap(this.map)
          zone.marker.setMap(this.map)
        })
      } else {
        this.zones.forEach(zone => {
          zone.polygon.setMap(null)
          zone.marker.setMap(null)
        })
      }
    }
  },
  computed: {
    google: gmapApi,
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>
<style scoped>
.zones-containor {
  display: flex;
  padding: 10px;
  height: 90vh;
  gap: 10px;
}

.map-div {
  flex: 2;
  height: 90vh;
  padding: 10px;
}

#zone-map {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.mobile-toggle {
  display: none;
  margin-bottom: 10px;
  text-align: center;
}

.btn-toggle {
  width: 100%;
  background-color: #f7941e;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

.btn-toggle:hover {
  background-color: #e68312;
}

.zones-list-div {
  margin: 5px;
  padding: 10px;
  width: 280px;
  min-width: 250px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.btn-kne-orange {
  margin-top: 5px;
  margin-bottom: 5px;
}

.btns-cont {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 5px;
}

.zone-name {
  text-transform: capitalize;
  font-size: 15px;
  margin: auto 5px;
  cursor: pointer;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zone-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-bottom: 8px;
  background: #fafafa;
  transition: background-color 0.2s ease;
}

.zone-div:hover {
  background: #f9f9f9;
}

.zone-btns-cont {
  display: flex;
  align-items: center;
  gap: 4px;
}

.svg-icn {
  width: 1rem;
  vertical-align: middle;
}

.btn-view,
.btn-edit,
.btn-del {
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  padding: 2px 4px;
}

.btn-view {
  border: 1px solid #1ea7fd;
  color: #1ea7fd;
}

.btn-edit {
  border: 1px solid #4ade80;
  color: #4ade80;
}

.btn-del {
  border: 1px solid #f00;
  color: #f00;
}

.zones-div {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  margin-top: 10px;
}

.pr-ctr {
  display: flex;
  align-items: center;
  height: 35px;
  gap: 4px;
}

.pr-ctr input {
  height: 32px;
}

.w-btn {
  width: 32px;
  background-color: white;
  border: 1px solid #ddd;
  height: 32px;
  cursor: pointer;
}

.w-btn:focus {
  outline: none;
}

.active {
  background-color: #f7941e;
  color: white;
}

.n-b-r {
  border-right: none !important;
}

.selectall-ctr {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  margin-bottom: 8px;
}

.selectall-ctr input {
  width: 18px;
  height: 18px;
}

.selectall-ctr h1 {
  font-size: 16px;
  margin: 0;
}

.search-inp {
  border: 1px solid #ddd !important;
  height: 32px;
}

.fa-search {
  font-size: 85%;
}

/* --- RESPONSIVE BREAKPOINTS --- */

@media (max-width: 900px) {
  .zones-containor {
    gap: 8px;
  }

  .zones-list-div {
    width: 240px;
  }

  /* .map-div {
    flex: 1.5;
  } */
}

/* Mobile: stack vertically */
@media (max-width: 700px) {
  .zones-containor {
    flex-direction: column;
    height: auto;
  }

  .mobile-toggle {
    display: block;
  }

  .zones-containor {
    flex-direction: column;
  }

  .map-div {
    flex: 0 0 auto;
    width: 100%;
    padding: 6px;
    height: 60vh; /* big canvas for drawing zones */
  }

  .zones-list-div {
    width: 100%;
    height: calc(40vh - 20px); /* smaller panel to allow map to be primary */
    overflow-y: auto;
    margin-top: 6px;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #eee;
    display: block; /* v-show will handle visibility */
  }

  .btns-cont {
    flex-direction: column;
  }

  .pr-ctr {
    flex-wrap: wrap;
    height: auto;
  }

  .pr-ctr input,
  .search-inp {
    width: 100%;
  }

  .w-btn {
    width: 40px;
    height: 34px;
  }

  .btn-kne-orange,
  .btn-blk {
    width: 100%;
  }
}

/* Very small screens */
@media (max-width: 440px) {
  .zone-name {
    font-size: 14px;
  }

  .zone-div {
    flex-wrap: wrap;
  }

  .zone-btns-cont {
    justify-content: flex-end;
    width: 100%;
    margin-top: 4px;
  }

  .zones-list-div {
    padding: 8px;
  }
}
</style>
